import { CircularProgress, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import * as EngineHelper from '../../api/engine/engineHelper';
import { IGetEnginePreviewResponse } from '../../api/engine/iApiResponse';
import { route } from '../../route/Index';
import { EPropellerDirectionWithRespectToTheQuay, ETypeOfPropeller } from '../../shared/enum';

interface IEnginePanelProps {}

const EnginePanelContainer = styled(Container)`
    padding: 0;
    flex-grow: 1;
`;

const EnginePanel = (props: IEnginePanelProps) => {
    const { t } = useTranslation();

    const navigate = useNavigate();

    const [enginePreview, setEnginePreview] = React.useState<IGetEnginePreviewResponse[]>();
    const [isLoading, setIsLoading] = React.useState(false);

    React.useEffect(() => {
        const fetchEnginePreview = async () => {
            setIsLoading(true);
            let res = await EngineHelper.getEngineTemplatesAsync();
            setEnginePreview(res.data);
            setIsLoading(false);
        };

        fetchEnginePreview();
    }, []);

    const handleGoToEngine = (id: number) => navigate(route.backofficeEngine.replace(':param', id.toString()));

    return (
        <EnginePanelContainer maxWidth='md'>
            <Stack height='100%' direction='column' spacing={4}>
                <Stack direction='row' justifyContent='space-between'>
                    <Typography variant='h1' gutterBottom>
                        {t('engineType')}
                    </Typography>
                </Stack>
                {isLoading && <CircularProgress />}
                {!isLoading && enginePreview?.length! > 0 && (
                    <>
                        <Stack flexGrow={1}>
                            <TableContainer>
                                <Table sx={{ minWidth: 650 }} aria-label='simple table'>
                                    <TableHead variant='greenLightWithoutBorder'>
                                        <TableRow>
                                            <TableCell>{t('typeOfPropeller')}</TableCell>
                                            <TableCell align='center'>{t('propellerDirectionWithRespectToTheQuay')}</TableCell>
                                            <TableCell align='right'>{t('numberOfPropellers')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {enginePreview!.map(x => (
                                            <TableRow key={x.id} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell onClick={() => handleGoToEngine(x.id)} component='th' scope='row'>
                                                    {x.typeOfPropeller == ETypeOfPropeller.MainPropeller ? t('main') : t('bowThruster')}
                                                </TableCell>
                                                <TableCell onClick={() => handleGoToEngine(x.id)} align='center'>
                                                    {x.propellerDirectionWithRespectToTheQuay == EPropellerDirectionWithRespectToTheQuay.Parallel ? t('parallel') : t('transversal')}
                                                </TableCell>
                                                <TableCell onClick={() => handleGoToEngine(x.id)} align='right'>
                                                    {x.numberOfPropellers}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Stack>
                    </>
                )}
                {!isLoading && enginePreview?.length! == 0 && <div>Empty</div>}
            </Stack>
        </EnginePanelContainer>
    );
};

export default EnginePanel;
